import UncontrolledPopover from 'components/SafeUncontrolledPopover';
import React, { FC, MouseEventHandler } from 'react';

type UncontrolledPopoverProps = React.ComponentProps<
  typeof UncontrolledPopover
>;

const ScrollableUncontrolledPopover: FC<UncontrolledPopoverProps> = ({
  ...props
}) => {
  const stopPropagation: MouseEventHandler = (e) => {
    e.stopPropagation();
  };

  return (
    <UncontrolledPopover {...props}>
      <div className="popover-scrollable-content" onWheel={stopPropagation}>
        {props.children}
      </div>
    </UncontrolledPopover>
  );
};

export default ScrollableUncontrolledPopover;
